import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  searchInput: {
    marginBottom: '2rem',
  },
  inputStyles: {
    fontSize: '1.5rem',
  },
  treeItemLabel: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    maxWidth: 'calc(100% - 20px)',
  },
  treeItem: {
    marginBottom: '5px',
  },
}))
